import { axiosRequest } from "../../configs/axios.config";
import { commonsHelper } from "../../../helpers";
export class OrganizationService {
  getSelectionProcesses(
    organizationSlug,
    tenantId,
    page = 1,
    items = 99999,
    params = {}
  ) {
    
    const url = !!!tenantId
      ? `/organizations/${organizationSlug}/selection_processes?page=${page}&items=${items}`
      : `/tenants/${tenantId}/organizations/${organizationSlug}/selection_processes?page=${page}&items=${items}`;
      
    return axiosRequest
      .post(
        url,
        params
      )
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }

  notificationLinks(value, success, error){
    axiosRequest
      .post("/organizations/notification_links", { notification_links: value })
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  providers(success, error){
    axiosRequest
      .get("/organizations/providers")
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  updateRequestType( data ) {
    axiosRequest
      .patch(`/organizations/update_request_type`, data)
      .then(({ data }) => success(data))
      .catch(({ errorResp }) => error(errorResp));
  }
}